<template>
  <div class="apply-flow">
    <div class="apply-flow-title">报名流程</div>
    <div class="apply-flow-line">
      <div
        class="apply-flow-line-item"
        v-for="item in list"
        :key="item.num"
        :class="{ 'active': item.num <= currentStep }"
      >
        <div class="apply-flow-line-item-icon">
          {{item.num}}
          <div class="apply-flow-line-item-text">{{item.text}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="stylus" scoped>
@import "../styles/variable.styl";

.apply-flow {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  padding: 45px 60px 100px;

  .apply-flow-title {
    font-size: $ucar_font_h5;
    margin-bottom: 40px;
    color: $ucar_main_color;
  }

  .apply-flow-line {
    width: 100%;
    display: flex;
    min-width: 0;
    align-items: center;
    color: #8d8275;

    .apply-flow-line-item {
      display: flex;
      flex: 1 0 52px;
      align-items: center;
      min-width: 0;

      .apply-flow-line-item-icon {
        box-sizing: border-box;
        position: relative;
        border: 1px solid currentColor; /*no*/
        border-radius: 50%;
        height: 40px;
        line-height: 36px;
        width: 40px;
        text-align: center;
        font-size: 16px;
        margin: 0 6px;
      }

      .apply-flow-line-item-text {
        position: absolute;
        top: calc(100% + 20px);
        left: 50%;
        transform: translate3d(-50%, 0, 0);
        font-size: 26px;
        white-space: nowrap;
        text-align: center;
      }

      &::before {
        content: "";
        height: 1px; /*no*/
        background-color: currentColor;
        flex: 1 0 0;
      }

      &:first-child {
        flex: 0 0 52px;
      }

      &:first-child::before {
        content: none;
      }

      &.active {
        color: $ucar_main_color;
      }
    }
  }
}
</style>

<script>
export default {
  data () {
    return {}
  },

  props: {
    list: {
      type: Array,
      default: () => []
    },
    currentStep: {
      type: Number,
      default: 0
    }
  }
}
</script>
